// extracted by mini-css-extract-plugin
export default {"artistCard":"ArtistCard__artistCard--JRQ1B","cover":"ArtistCard__cover--cKId7","info":"ArtistCard__info--S5S1_"};